<template>
  <ContextualRouterLink :to="collection.getEditUrl(props.item)" class="text-jananavy-600 hover:text-jananavy-900 font-medium">
    Edit <span class="sr-only">{{ collection.getName(props.item) }}</span>
  </ContextualRouterLink>
</template>

<script setup>

import { getCollection } from '@/kernel/collections';

import ContextualRouterLink from '@/components/links/contextual-router-link.vue';

const props = defineProps({
  column: Object,
  item: Object,
  collection: String
});

const collection = getCollection(props.collection);

</script>
